module.exports = __webpack_public_path__ + "img/neo-180.e445605e.png";